/** @file samplePose: several nodes sampled at one frame of a clip (empty samples dropped). */
import type { Clip, NodeKey } from '@zilo/pose3d-format/types/clip';
import { sampleNodeKey } from './sampleNodeKey';

/** `sampleNodeKey` for each of `nodes` at `frame`, keeping only non-empty samples. */
export function samplePose(clip: Pick<Clip, 'keys'>, frame: number, nodes: readonly string[]): Record<string, NodeKey> {
  return Object.fromEntries(nodes.map((n) => [n, sampleNodeKey(clip, n, frame)] as const).filter(([, k]) => Object.keys(k).length > 0));
}
